import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "Home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "Home-intro-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Home-intro-img-inner" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/intro.jpg 1x, /images/home/intro@2x.jpg 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/home/intro.jpg",
        alt: "Intro home"
      })
    ])
  ])
], -1)
const _hoisted_3 = { class: "Home-intro-content" }
const _hoisted_4 = { class: "Home-intro-content-title h1" }
const _hoisted_5 = { class: "Home-intro-content-list" }
const _hoisted_6 = {
  class: "Home-bartenders",
  "data-scroll-section": ""
}
const _hoisted_7 = { class: "Home-bartenders-intro-title" }
const _hoisted_8 = { class: "h1" }
const _hoisted_9 = { class: "Home-bartenders-intro-content" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["onMouseenter"]
const _hoisted_12 = ["onMouseenter"]
const _hoisted_13 = ["onMouseenter"]
const _hoisted_14 = { class: "Home-bartenders-chapters-cursor" }
const _hoisted_15 = ["data-line", "data-n"]
const _hoisted_16 = ["srcset"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  class: "Home-video padded",
  "data-scroll-section": ""
}
const _hoisted_19 = ["tabindex", "aria-hidden"]
const _hoisted_20 = { class: "Home-video-player-inner" }
const _hoisted_21 = { class: "grid" }
const _hoisted_22 = { class: "Home-video-content" }
const _hoisted_23 = { class: "Home-video-content-title h4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "button-watch-icon" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "Home-video-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Home-video-img-inner" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/player.jpg 1x, /images/home/player@2x.jpg 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/home/player.jpg",
        alt: "player home"
      })
    ])
  ])
], -1)
const _hoisted_26 = {
  class: "Home-passion",
  "data-scroll-section": ""
}
const _hoisted_27 = { class: "Home-passion-title h1" }
const _hoisted_28 = {
  class: "Home-practical",
  "data-scroll-section": ""
}
const _hoisted_29 = { class: "Home-practical-title" }
const _hoisted_30 = { class: "h1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "Home-practical-img" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Home-practical-img-inner" }, [
    /*#__PURE__*/_createElementVNode("picture", null, [
      /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/practical.jpg 1x, /images/home/practical@2x.jpg 2x" }),
      /*#__PURE__*/_createElementVNode("img", {
        src: "/images/home/practical.jpg",
        alt: "practical home"
      })
    ])
  ])
], -1)
const _hoisted_32 = { class: "Home-practical-content" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "Home-register-content" }
const _hoisted_35 = { class: "h1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "Home-register-img" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/register.png 1x, /images/home/register@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/home/register.png",
      alt: "register home"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ParallaxObject = _resolveComponent("ParallaxObject")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_LineParallax = _resolveComponent("LineParallax")!
  const _component_CursorFollow = _resolveComponent("CursorFollow")!
  const _component_RoundSection = _resolveComponent("RoundSection")!
  const _component_PassionSlider = _resolveComponent("PassionSlider")!
  const _component_Testimonials = _resolveComponent("Testimonials")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_AppearObject, {
          class: "Home-intro",
          "data-scroll-section": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ParallaxObject, {
              class: "Home-intro-inner padded grid",
              ratio: -0.2
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h1", _hoisted_4, [
                    _createVNode(_component_LineByLine, {
                      innerHTML: _ctx.$t('home.title1')
                    }, null, 8, ["innerHTML"])
                  ]),
                  _createElementVNode("ul", _hoisted_5, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_ButtonHover, {
                        to: "/register",
                        class: "button-primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.cta-register')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_ButtonHover, {
                        to: "/team",
                        class: "button-secondary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.cta-staff')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["ratio"])
          ]),
          _: 1
        }),
        _createElementVNode("section", _hoisted_6, [
          _createVNode(_component_RoundSection, { class: "Home-bartenders-inner" }, {
            default: _withCtx(() => [
              _createVNode(_component_AppearObject, { class: "Home-bartenders-intro padded grid" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h2", _hoisted_8, [
                      _createVNode(_component_LineByLine, {
                        innerHTML: _ctx.$t('home.title2')
                      }, null, 8, ["innerHTML"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", {
                      class: "h3",
                      innerHTML: _ctx.$t('home.description2')
                    }, null, 8, _hoisted_10)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_CursorFollow, { class: "Home-bartenders-chapters" }, {
                cursor: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (line) => {
                      return _createElementVNode("div", {
                        class: "Home-bartenders-chapters-cursor-line",
                        key: line
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                          return _createElementVNode("div", {
                            key: n,
                            class: _normalizeClass([{ 'is-active': _ctx.currentLineItem === line*10 + n  }, "Home-bartenders-chapters-cursor-img"])
                          }, [
                            _createElementVNode("picture", {
                              "data-line": line,
                              "data-n": n
                            }, [
                              _createElementVNode("source", {
                                srcset: `/images/home/chapters/${ _ctx.$t('home.line' + line + '-item' + n + '-picture') }.jpg 1x, /images/home/chapters/${ _ctx.$t('home.line' + line + '-item' + n + '-picture') }@2x.jpg 2x`
                              }, null, 8, _hoisted_16),
                              _createElementVNode("img", {
                                src: `/images/home/chapters/${ _ctx.$t('home.line' + line + '-item' + n + '-picture') }.jpg`,
                                alt: "bartenders home"
                              }, null, 8, _hoisted_17)
                            ], 8, _hoisted_15)
                          ], 2)
                        }), 64))
                      ])
                    }), 64))
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_LineParallax, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                        return _createElementVNode("ul", {
                          key: n,
                          class: "Home-bartenders-chapters-list"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("li", {
                              key: n,
                              onMouseenter: ($event: any) => (_ctx.onMouseEnter(1, n)),
                              class: "Home-bartenders-chapters-list-item h1"
                            }, _toDisplayString(_ctx.$t('home.line1-item'+n)), 41, _hoisted_11)
                          }), 64))
                        ])
                      }), 64))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_LineParallax, { direction: 'left' }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                        return _createElementVNode("ul", {
                          key: n,
                          class: "Home-bartenders-chapters-list"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("li", {
                              key: n,
                              onMouseenter: ($event: any) => (_ctx.onMouseEnter(2, n)),
                              class: "Home-bartenders-chapters-list-item h1"
                            }, _toDisplayString(_ctx.$t('home.line2-item'+n)), 41, _hoisted_12)
                          }), 64))
                        ])
                      }), 64))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_LineParallax, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                        return _createElementVNode("ul", {
                          key: n,
                          class: "Home-bartenders-chapters-list"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("li", {
                              key: n,
                              onMouseenter: ($event: any) => (_ctx.onMouseEnter(3, n)),
                              class: "Home-bartenders-chapters-list-item h1"
                            }, _toDisplayString(_ctx.$t('home.line3-item'+n)), 41, _hoisted_13)
                          }), 64))
                        ])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_18, [
          _createVNode(_component_AppearObject, {
            class: _normalizeClass([{ 'is-video-active': _ctx.videoActive }, "Home-video-player"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("iframe", {
                tabindex: _ctx.videoActive ? 0 : -1,
                "aria-hidden": _ctx.videoActive ? 'true' : 'false',
                ref: "iframe",
                title: "vimeo-player",
                src: "https://player.vimeo.com/video/719176614?h=7bd8bcb094&color=747a7d&title=0&byline=0&portrait=0",
                width: "640",
                height: "360",
                frameborder: "0",
                allowfullscreen: "",
                allow: "autoplay; fullscreen; picture-in-picture"
              }, null, 8, _hoisted_19),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h2", _hoisted_23, [
                        _createVNode(_component_LineByLine, {
                          innerHTML: _ctx.$t('home.video-title')
                        }, null, 8, ["innerHTML"])
                      ]),
                      _createVNode(_component_ButtonHover, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.videoActive = true)),
                        class: "Home-video-content-btn button-watch"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.video-cta')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_25
                ])
              ])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("section", _hoisted_26, [
          _createVNode(_component_AppearObject, { class: "padded grid" }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_27, [
                _createVNode(_component_LineByLine, {
                  innerHTML: _ctx.$t('home.title3')
                }, null, 8, ["innerHTML"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_PassionSlider)
        ]),
        _createElementVNode("section", _hoisted_28, [
          _createVNode(_component_RoundSection, { class: "Home-practical-inner" }, {
            default: _withCtx(() => [
              _createVNode(_component_AppearObject, { class: "padded grid" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("h2", _hoisted_30, [
                      _createVNode(_component_LineByLine, {
                        innerHTML: _ctx.$t('home.practical-title')
                      }, null, 8, ["innerHTML"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_AppearObject, { class: "padded grid" }, {
                default: _withCtx(() => [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", {
                        class: "h3",
                        innerHTML: _ctx.$t('home.practical-description')
                      }, null, 8, _hoisted_33),
                      _createVNode(_component_ButtonHover, {
                        to: "/practical",
                        onClick: _ctx.onRegisterClick,
                        class: "Home-practical-content-link button button--white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('home.practical-button')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_Testimonials, {
          class: "Home-testimonials",
          "background-color": "redLight",
          content: _ctx.testimonials
        }, null, 8, ["content"]),
        _createVNode(_component_AppearObject, {
          class: "Home-register",
          "data-scroll-section": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RoundSection, { class: "Home-register-inner padded grid" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_35, [
                      _createVNode(_component_LineByLine, {
                        innerHTML: _ctx.$t('home.title4')
                      }, null, 8, ["innerHTML"])
                    ]),
                    _createVNode(_component_ButtonHover, {
                      to: "/register",
                      onClick: _ctx.onRegisterClick,
                      class: "Home-register-content-link button button--white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('home.cta-register2')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}